import { Menu, Lock } from "lucide-react";
import { C } from "../constants/colors";
import { MODULE_META } from "../constants/modules";

export function LockedModulePanel({ moduleId, isMobile, onMenuOpen, lockedMessage, lockedCTA }) {
  const meta = MODULE_META[moduleId];
  const Icon = meta?.icon;
  const message = lockedMessage || "This module is part of the Business Brilliance Accelerator. Enroll to unlock all seven modules and build your complete business foundation.";
  const cta = lockedCTA || { label: "Apply for the Accelerator →", href: "https://info.tevrawood.com/business-brilliance-accelerator" };
  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, background: "#F8F7FA", height: "100%", overflow: "hidden" }}>
      <div style={{
        background: C.indigo, padding: isMobile ? "13px 14px" : "17px 22px",
        borderBottom: `3px solid ${meta?.color || C.teal}`,
        display: "flex", alignItems: "center", gap: 10, flexShrink: 0,
      }}>
        {isMobile && (
          <button onClick={onMenuOpen} style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", padding: "10px 14px 10px 6px", display: "flex", alignItems: "center", minWidth: 44, minHeight: 44, flexShrink: 0 }}>
            <Menu size={24} />
          </button>
        )}
        <h2 style={{ color: "#fff", margin: 0, fontSize: isMobile ? 15 : 16, fontWeight: 700 }}>{meta?.label}</h2>
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 24px", textAlign: "center" }}>
        <div style={{
          width: 56, height: 56, borderRadius: "50%",
          background: `${C.teal}18`, border: `1px solid ${C.teal}33`,
          display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20,
        }}>
          <Lock size={22} color={C.teal} />
        </div>
        <h3 style={{ margin: "0 0 14px", fontSize: 16, fontWeight: 700, color: C.indigo }}>{meta?.label}</h3>
        <p style={{ margin: "0 0 28px", fontSize: 13, color: "#666", lineHeight: 1.7, maxWidth: 320 }}>
          {message}
        </p>
        {cta && (
          <a
            href={cta.href}
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-flex", alignItems: "center", gap: 7,
              padding: "11px 22px", borderRadius: 10,
              background: C.teal, color: "#fff",
              fontSize: 13, fontWeight: 700, textDecoration: "none",
              boxShadow: `0 4px 14px ${C.teal}44`,
            }}
          >
            {cta.label}
          </a>
        )}
      </div>
    </div>
  );
}
